module.exports = __webpack_public_path__ + "img/Flag_of_Morocco.a4020743.svg";